import { accountManager } from './services/AccountManager.js';
import { UIManager } from './ui/UIManager.js';
import { stateService } from './utils/StateService.js';
import { featureFlags } from './services/FeatureFlagService.js';

// Minimal UI Manager for auth only
const uiManager = new UIManager(accountManager, stateService);

// --- Auth Hookup ---
accountManager.onChanged = (user) => {
    uiManager.updateAuthUI(user, {});

    // Redirect to app if authenticated and not already on app page
    if (user && window.location.pathname !== '/app' && window.location.pathname !== '/app.html') {
        if (window.innerWidth > 768) {
            // Preserve query parameters (e.g. ?verify=...)
            window.location.href = '/app' + window.location.search;
        }
    }
};

// --- Landing Page Logic ---
const startAppBtn = document.getElementById('start-app-btn');
const navLoginBtn = document.getElementById('nav-login-btn');

startAppBtn?.addEventListener('click', () => {
    if (window.mixpanel) window.mixpanel.track('Click Request Access', { source: 'landing' });
    // Direct navigation to app (skip signup trigger if in free mode)
    if (featureFlags.isEnabled('free_mode')) {
        window.location.href = '/app';
    } else {
        window.location.href = '/app#signup';
    }
});

navLoginBtn?.addEventListener('click', () => {
    if (window.mixpanel) window.mixpanel.track('Click Sign In Nav', { source: 'landing' });
    // Trigger login modal
    const authBtn = document.getElementById('auth-btn');
    if (authBtn) {
        authBtn.click();
    } else {
        // Fallback if auth-btn (which is inside app-view usually) isn't present
        // But in our split, index.html might not have app-view.
        // We need to ensure login modal is triggerable.
        // UIManager attaches listeners to #auth-btn. 
        // In the new split index.html, we should probably just show the modal directly.
        const modal = document.getElementById('login-modal');
        if (modal) {
            modal.classList.remove('hidden');
            // Default to signin view
            document.getElementById('signin-view')?.classList.remove('hidden');
            document.getElementById('signup-view')?.classList.add('hidden');
            document.getElementById('forgot-password-view')?.classList.add('hidden');
        }
    }
});

// Auto-enter app if already signed in
if (accountManager.isAuthenticated() && window.location.pathname !== '/app' && window.location.pathname !== '/app.html') {
    if (window.innerWidth > 768) {
        window.location.href = '/app' + window.location.search;
    }
}

// Verification Logic for Landing Page (Unauthenticated or just arriving)
const urlParams = new URLSearchParams(window.location.search);
const verifyToken = urlParams.get('verify');
// Only verify here if NOT authenticated (authenticated users are redirected to app)
if (verifyToken && !accountManager.isAuthenticated()) {
    accountManager.verifyEmail(verifyToken).then((data) => {
        if (data.isWaitlisted) {
            alert(`Verified! You are confirmed on the waitlist (#${data.position}). We will notify you when your spot opens.`);
        } else {
            alert('Email verified successfully! You can now sign in.');
        }
        window.history.replaceState({}, document.title, window.location.pathname);
    }).catch(err => {
        // console.error('[landing] Verification failed', err);
        alert('Verification failed: ' + err.message);
        window.history.replaceState({}, document.title, window.location.pathname);
    });
}

// Initial Auth and Landing UI update
uiManager.updateLandingUI();
featureFlags.refresh(accountManager.token).then(() => {
    uiManager.updateAuthUI(accountManager.currentUser, {});
    uiManager.updateLandingUI();
});

